import React from 'react';
import { cn } from '@/lib/utils';

interface ToggleProps {
  pressed?: boolean;
  onPressedChange?: (pressed: boolean) => void;
  'aria-label'?: string;
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export const Toggle: React.FC<ToggleProps> = ({
  pressed = false,
  onPressedChange,
  'aria-label': ariaLabel,
  className,
  children,
  ...props
}) => {
  const handleClick = () => {
    if (onPressedChange) {
      onPressedChange(!pressed);
    }
  };

  const combinedClassName = cn(
    'inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors',
    'data-[state=on]:bg-accent data-[state=on]:text-accent-foreground',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
    'disabled:pointer-events-none disabled:opacity-50',
    pressed ? 'bg-accent text-accent-foreground' : 'bg-transparent hover:bg-muted',
    className
  );

  return (
    <button
      type="button"
      aria-pressed={pressed}
      aria-label={ariaLabel}
      data-state={pressed ? 'on' : 'off'}
      className={combinedClassName}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Toggle; 